<div class="app-basic-layout">
  <app-header-basic-layout></app-header-basic-layout>
  <div class="w-100">
    <div class="m-auto panel_container">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer-basic-layout [customClass]="basicFooter?'footer_basic':''"></app-footer-basic-layout>
</div>